<template>
  <div>
    <q-card v-if="showCardPesquisa">
      <q-card-main>
        <q-collapsible
          class="gvn-collapse-filtro"
          icon="fa fa-filter"
          :opened="showBuscaAvancadaAberta"
          label="Pesquisa avançada"
          v-show="showBuscaAvancada"
        >
          <slot></slot>
        </q-collapsible>
        <div class="row title">
          <div
            class="termo"
            v-if="showTermoPesquisa"
          >
            <q-search
              class="gvn-q-search"
              v-model="termo"
              placeholder="Pesquisar"
              :debounce=1
              :max-length="tamanhoTermoPesquisa"
              @keyup.13="pesquisarTermo()"
              :clearable="false"
            />
          </div>
        </div>
        <div
          class="row mrg-t-10"
          v-show="showBotoesPesquisa"
        >
          <div
            class="col-6 text-left"
            v-if="validarAntesDePesquisar"
          >
            <!-- Botão de Pesquisar e Limpar -->
            <q-btn
              icon="fa fa-search"
              style="background: #550059 !important; color: white"
              @click="pesquisarAposValidar"
            >
              &ensp;&ensp;Pesquisar
            </q-btn>
            &ensp;&ensp;
            <q-btn
              icon="fa fa-eraser"
              @click="limparFiltros"
            >
              &ensp;&ensp;Limpar
            </q-btn>
          </div>
          <div
            class="col-6 text-left"
            v-else
          >
            <!-- Botão de Pesquisar e Limpar -->
            <q-btn
              icon="fa fa-search"
              style="background: #550059 !important; color: white"
              @click="pesquisar"
            >
              &ensp;&ensp;Pesquisar
            </q-btn>
            &ensp;&ensp;
            <q-btn
              icon="fa fa-eraser"
              @click="limparFiltros"
            >
              &ensp;&ensp;Limpar
            </q-btn>
          </div>

          <div
            class="col-6 text-right"
            v-if="showImprimirENovo"
          >
            <q-btn
              v-if="showBtnAdicional"
              :icon="btnAdicionalIcone"
              :color="btnAdicionalCor"
              @click="btnAdicionalFuncao"
            >
              &ensp;&ensp;{{ btnAdicionalDescricao }}
            </q-btn>
            {{ showBtnAdicional ? '&ensp;' : ''}}
            <q-btn-dropdown
              icon="fa fa-file-export"
              label="Exportar"
            >
              <q-list link>
                <q-item
                  clickable
                  @click.native="exportarCsv"
                >
                  <q-item-main>
                    <q-item-tile label>CSV</q-item-tile>
                  </q-item-main>
                </q-item>
                <q-item
                  clickable
                  @click.native="exportarHtml"
                >
                  <q-item-main>
                    <q-item-tile label>HTML</q-item-tile>
                  </q-item-main>
                </q-item>
              </q-list>
            </q-btn-dropdown>
            &ensp;
            <q-btn
              v-if="novo !== null && showBotaoNovo"
              icon="fa fa-plus"
              color="primary"
              @click="novoF"
            >
              &ensp;&ensp;Novo
            </q-btn>
          </div>
        </div>
      </q-card-main>
      <!-- BARRA DE PROCESSAMENTO -->
      <div style="height: 1px !important">
        <q-progress
          :indeterminate="true"
          v-show="progresso"
        />
      </div>
    </q-card>
    <div class="mrg-t-0">
      <g-datatable
        ref="refPesquisaResultado"
        v-model="pagina"
        :colunas=colunasPropriedade
        :colunasExpansao=colunasExpansao
        :operacoes=operacoes
        :operacoesQFab=operacoesQFab
        :api=apiPesquisa
        :apiRelatorio="apiRelatorio"
        :getFiltroPesquisa="getFiltros"
        :elementosPorPagina=elementosPorPagina
        :exibirColunaOperacoes=exibirColunaOperacoes
        :exibirColunaOperacoesQFab=exibirColunaOperacoesQFab
        :confVisualizar=confVisualizar
        :confEditar=confEditar
        :confExcluir=confExcluir
        :carregamentoInicial=carregamentoInicial
        :scrollHorizontal=scrollHorizontal
        :acaoPosPesquisa=acaoPosPesquisa
      />
    </div>
  </div>
</template>

<script>
import util from 'components/util/util'
import GDatatable from 'components/util/gDatatable'
export default {
  data () {
    return {
      pagina: 1,
      termo: '',
      progresso: false,
      desabilitarImpressao: false,
      chaveRelatorioObjExportacaoLocalStorage: 'RELATORIO_OBJETO_EXPORTACAO'
    }
  },
  methods: {
    limpar () {
      this.$refs['refPesquisaResultado'].limpar()
    },
    limparFiltros () {
      this.termo = ''
      if (this.limparFiltroLocal) {
        this.limparFiltroLocal()
      }
      this.$refs['refPesquisaResultado'].limpar()
      // this.$refs['refPesquisaResultado'].pesquisar(1)
    },
    pesquisar (pagina) {
      this.$refs['refPesquisaResultado'].pesquisar(pagina > 0 ? pagina : 1)
    },
    pesquisarAposValidar () {
      if (this.validarAntesDePesquisar() === true) {
        this.$refs['refPesquisaResultado'].pesquisar(1)
      }
    },
    totalElementos () {
      return this.$refs['refPesquisaResultado'].getDados()
    },
    pesquisarTermo () {
      this.$refs['refPesquisaResultado'].pesquisar(1)
    },
    getFiltros () {
      var filtro = '&termoBase64=' + util.paraBase64(this.termo)
      if (this.filtroAdicional) filtro += this.filtroAdicional()

      return filtro
    },
    dados () {
      return this.$refs['refPesquisaResultado'].dados
    },
    getDadosSelecionadosCheckbox () {
      return this.$refs['refPesquisaResultado'].getDadosSelecionadosCheckbox()
    },
    getDadosSelecionadosRadio () {
      return this.$refs['refPesquisaResultado'].getDadosSelecionadosRadio()
    },
    desabilitarImprimir () {
      let resultado = this.$refs['refPesquisaResultado']
      let dados = null
      if (resultado) {
        dados = resultado.dados
      }
      if (!resultado ||
        !resultado.dados ||
        resultado.dados.length === 0) {
        this.desabilitarImpressao = true
      } else {
        this.desabilitarImpressao = false
      }
      // Chamar a função customizada
      this.acaoPosPesquisa(dados)
    },
    recuperarObjetoExportacao () {
      let objExportacao = {}
      // Buscando os dados da grid
      let dados = this.$refs['refPesquisaResultado'].getDados()
      if (dados.length === 0) {
        util.exibirToastAviso('Resultado de pesquisa vazio')
        return null
      }
      objExportacao.dados = dados
      objExportacao.colunas = this.colunasPropriedade.map(c => c.propriedade)
      objExportacao.colunasDescricao = this.colunasPropriedade.map(c => c.cabecalhoEtiqueta)
      // removendo a última coluna, "Operações"
      objExportacao.colunasDescricao.pop()
      return objExportacao
    },
    exportarCsv () {
      let objExportacao = this.recuperarObjetoExportacao()
      if (!objExportacao) {
        return
      }
      this.$refs['refPesquisaResultado'].pesquisarPaginaUnica((dados) => {
        // Exportando para CSV
        util.exportarParaCsv(dados, objExportacao.colunas, objExportacao.colunasDescricao)
      })
    },
    exportarHtml () {
      let objExportacao = this.recuperarObjetoExportacao()
      if (!objExportacao) {
        return
      }
      this.$refs['refPesquisaResultado'].pesquisarPaginaUnica((dados) => {
        objExportacao.dados = dados
        util.adicionarNoStorage(this.chaveRelatorioObjExportacaoLocalStorage, objExportacao)
        let routeData = this.$router.resolve({ name: 'relatorioHtml' })
        // Exportando para HTML
        window.open(routeData.href, '_blank')
      })
    },
    pararBarraProgresso () {
      this.$refs['refPesquisaResultado'].pararBarraProgresso()
    },
    temDados () {
      // console.log('TEMDA CALLED', this.$refs['refPesquisaResultado'])
      if (this.$refs['refPesquisaResultado'] === undefined) return false
      else {
        // console.log("TEM DADOS", this.$refs['refPesquisaResultado'].temDados(), this.$refs['refPesquisaResultado'].getDados())
        return this.$refs['refPesquisaResultado'].temDados()
      }
    }
  },
  props: {
    pesquisaraoLimpar: {
      type: Boolean,
      default: () => false
    },
    limparFiltroLocal: {
      type: Function
    },
    imprimir: {
      type: Function,
      default: null
    },
    novo: {
      type: Function,
      default: null
    },
    filtroAdicional: {
      type: Function
    },
    elementosPorPagina: {
      type: Number,
      default: null
    },
    colunasPropriedade: {
      type: Array,
      default: () => []
    },
    colunasExpansao: {
      type: Array,
      default: () => []
    },
    operacoes: {
      type: Array,
      default: () => []
    },
    operacoesQFab: {
      type: Array,
      default: () => []
    },
    apiPesquisa: {
      type: String,
      default: ''
    },
    apiRelatorio: {
      type: String,
      default: ''
    },
    visualizar: {
      type: Object,
      default: () => { }
    },
    editar: {
      type: Object,
      default: () => { }
    },
    excluir: {
      type: Object,
      default: () => { }
    },
    carregamentoInicial: {
      type: Boolean,
      default: () => true
    },
    exibirColunaOperacoes: {
      type: Boolean,
      default: () => true
    },
    exibirColunaOperacoesQFab: {
      type: Boolean,
      default: () => false
    },
    confVisualizar: {
      type: Object,
      default: () => ({
        clique: () => alert('Sem ação'),
        permissao: () => false,
        visivel: () => false
      })
    },
    confEditar: {
      type: Object,
      default: () => ({
        clique: () => alert('Sem ação'),
        permissao: () => false,
        visivel: () => false
      })
    },
    confExcluir: {
      type: Object,
      default: () => ({
        clique: () => alert('Sem ação'),
        permissao: () => false,
        visivel: () => false
      })
    },
    showCardPesquisa: {
      type: Boolean,
      default: () => true
    },
    showImprimirENovo: {
      type: Boolean,
      default: () => true
    },
    showTermoPesquisa: {
      type: Boolean,
      default: () => true
    },
    showBotoesPesquisa: {
      type: Boolean,
      default: () => true
    },
    showBuscaAvancada: {
      type: Boolean,
      default: () => true
    },
    showBuscaAvancadaAberta: {
      type: Boolean,
      default: () => false
    },
    scrollHorizontal: {
      type: Boolean,
      default: () => false
    },
    acaoPosPesquisa: {
      type: Function,
      default: () => { }
    },
    tamanhoTermoPesquisa: {
      type: Number,
      default: null
    },
    showBotaoNovo: {
      type: Boolean,
      default: () => false
    },
    validarAntesDePesquisar: {
      type: Function
    },
    exibirBotaoImprimir: {
      type: Boolean,
      default: () => false
    },
    showBtnAdicional: {
      type: Boolean,
      default: () => false
    },
    btnAdicionalIcone: {
      type: String,
      default: 'fas fa-plus'
    },
    btnAdicionalCor: {
      type: String,
      default: 'primary'
    },
    btnAdicionalDescricao: {
      type: String,
      default: 'Botão Adicional'
    },
    btnAdicionalFuncao: {
      type: Function,
      default: null
    }
  },
  computed: {
    novoF: function () {
      return this.novo || (() => alert(';('))
    },
    imprimirF: function () {
      return this.imprimir || (() => alert(';('))
    },
    visualizarImpressao () {
      return this.imprimir !== null && !this.desabilitarImpressao
    }
  },
  mounted () {
  },

  components: { GDatatable }
}
</script>

<style>
.title {
  display: flex;
}

.termo {
  flex: 1;
}

.novo {
  margin-left: 25px;
  width: 105px !important;
}

.gvn-q-search i:last-child {
  display: none;
}

/* GAMBIARRA, PARA MUDAR A COR DO ICONE DO COLAPSE (NÃO ME MATE, PF) */
.gvn-collapse-filtro .q-item-division {
  background: #dbdbdb;
}

.gvn-collapse-filtro .q-item-division:hover {
  background: #bebebe;
}

.gvn-collapse-filtro .q-item-icon {
  color: #093370;
}

.gvn-collapse-filtro .q-item-label {
  color: #093370;
}
</style>
